/* ============================================================
   bg-product-sidebar – apertura / chiusura drawer prodotto
   ============================================================ */

(function () {
  var OPEN_CLASS = 'is-open';
  var ACTIVE_CLASS = 'is-active';
  var BODY_LOCK_CLASS = 'bg-psd-body-lock';

  function getOverlay() {
    return document.getElementById('bg-psd-overlay');
  }

  function getAllSidebars() {
    return document.querySelectorAll('.bg-psd');
  }

  function openSidebar(id) {
    var sidebar = document.getElementById('bg-psd-' + id);
    if (!sidebar) return;

    closeAll();

    sidebar.classList.add(OPEN_CLASS);
    sidebar.setAttribute('aria-hidden', 'false');

    var overlay = getOverlay();
    if (overlay) overlay.classList.add(ACTIVE_CLASS);

    document.body.classList.add(BODY_LOCK_CLASS);

    var firstFocusable = sidebar.querySelector(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (firstFocusable) firstFocusable.focus();
  }

  function closeAll() {
    getAllSidebars().forEach(function (sb) {
      sb.classList.remove(OPEN_CLASS);
      sb.setAttribute('aria-hidden', 'true');
    });

    var overlay = getOverlay();
    if (overlay) overlay.classList.remove(ACTIVE_CLASS);

    document.body.classList.remove(BODY_LOCK_CLASS);
  }

  function initProductSidebars(root) {
    root = root || document;

    /* Trigger buttons */
    root.querySelectorAll('[data-bg-sidebar]').forEach(function (btn) {
      if (btn.dataset.bgSidebarInit) return;
      btn.dataset.bgSidebarInit = '1';
      btn.addEventListener('click', function () {
        openSidebar(btn.dataset.bgSidebar);
      });
    });

    /* Close buttons inside each sidebar */
    root.querySelectorAll('.bg-psd__close').forEach(function (btn) {
      if (btn.dataset.bgSidebarCloseInit) return;
      btn.dataset.bgSidebarCloseInit = '1';
      btn.addEventListener('click', closeAll);
    });

    /* Overlay click */
    var overlay = root.getElementById
      ? root.getElementById('bg-psd-overlay')
      : document.getElementById('bg-psd-overlay');
    if (overlay && !overlay.dataset.bgSidebarOverlayInit) {
      overlay.dataset.bgSidebarOverlayInit = '1';
      overlay.addEventListener('click', closeAll);
    }
  }

  /* ESC key to close */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') closeAll();
  });

  function boot() {
    initProductSidebars(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initProductSidebars(e.target || document);
  });
})();

/* ============================================================
   Restock notification — mostra un solo pulsante alla volta
   Logica:
     • Nessuna variante selezionata  → mostra pulsante principale (con "Seleziona...")
     • Variante in stock selezionata → mostra pulsante principale (Acquista)
     • Variante esaurita selezionata → mostra solo pulsante notify (Contattami)
   ============================================================ */

(function () {
  function syncRestockButton(container) {
    var submitBtn  = container.querySelector('.product_submit_button');
    var restockBtn = container.querySelector('.product-restore-email');
    if (!submitBtn || !restockBtn) return;

    var soldOutLabel  = (submitBtn.getAttribute('data-label-sold-out') || 'Esaurito').trim();
    var labelEl       = submitBtn.querySelector('.btn-label');
    var currentLabel  = labelEl ? labelEl.textContent.trim() : '';
    var isSoldOut     = submitBtn.disabled && currentLabel === soldOutLabel;

    if (isSoldOut) {
      /* variante esaurita: nasconde buy, mostra notify */
      submitBtn.style.setProperty('display', 'none', 'important');
      restockBtn.style.setProperty('display', 'flex', 'important');
    } else {
      /* nessuna variante / variante disponibile: mostra buy, nasconde notify */
      submitBtn.style.removeProperty('display');
      restockBtn.style.setProperty('display', 'none', 'important');
    }
  }

  function initRestockSync(root) {
    root = root || document;
    root.querySelectorAll('.button_buy-now').forEach(function (container) {
      if (container.dataset.restockSyncInit) return;
      container.dataset.restockSyncInit = '1';

      var submitBtn  = container.querySelector('.product_submit_button');
      var restockBtn = container.querySelector('.product-restore-email');
      if (!submitBtn || !restockBtn) return;

      syncRestockButton(container);

      /* Osserva cambi sul pulsante principale (testo + attributo disabled) */
      new MutationObserver(function () {
        syncRestockButton(container);
      }).observe(submitBtn, {
        attributes:    true,
        attributeFilter: ['disabled', 'class'],
        subtree:       true,
        characterData: true
      });

      /* Osserva anche l'aggiornamento dello style del notify button (app-driven) */
      new MutationObserver(function () {
        syncRestockButton(container);
      }).observe(restockBtn, { attributes: true, attributeFilter: ['style'] });
    });
  }

  function boot() { initRestockSync(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initRestockSync(e.target || document);
  });
})();

/* ============================================================
   bg-product-sidebar – FAQ accordion
   ============================================================ */

(function () {
  function initFaqAccordion(root) {
    root = root || document;
    root.querySelectorAll('.bg-psd__faq-btn').forEach(function (btn) {
      if (btn.dataset.faqInit) return;
      btn.dataset.faqInit = '1';

      btn.addEventListener('click', function () {
        var answer = btn.nextElementSibling;
        var isOpen = btn.getAttribute('aria-expanded') === 'true';

        if (isOpen) {
          btn.setAttribute('aria-expanded', 'false');
          answer.classList.remove('is-open');
        } else {
          btn.setAttribute('aria-expanded', 'true');
          answer.removeAttribute('hidden');
          answer.classList.add('is-open');
        }
      });
    });
  }

  function boot() {
    initFaqAccordion(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initFaqAccordion(e.target || document);
  });
})();

/* ============================================================
   Feedaty reviews sidebar – ricolora SVG stelle (nero/bianco)
   full_bluestars: celle #1D3653 → bianco, stelle #F4C15C → nero
   goldstars: stelle piene #f4c15c → nero, vuote #e7e7e7 invariate
   ============================================================ */

(function () {
  var STAR_SELECTOR = '#bg-psd-reviews .ratx_stars, #bg-psd-reviews .rev_stars';
  var EMPTY_STAR = '#E9ECEC';

  function recolorFeedatySvg(svgText) {
    return svgText
      .replace(/#1D3653/gi, '#FFFFFF')
      .replace(/#F4C15C/gi, '#000000')
      .replace(/#f4c15c/gi, '#000000')
      .replace(/fill="#ffffff"/gi, 'fill="' + EMPTY_STAR + '"')
      .replace(/fill="#FFFFFF"/gi, 'fill="' + EMPTY_STAR + '"');
  }

  function recolorStarImg(img) {
    if (!img || img.dataset.bgStarsRecolored === '1') return;
    var src = img.getAttribute('src');
    if (!src || src.indexOf('.svg') === -1) return;

    img.dataset.bgStarsRecolored = '1';

    fetch(src)
      .then(function (res) {
        if (!res.ok) throw new Error('SVG fetch failed');
        return res.text();
      })
      .then(function (svg) {
        var blob = new Blob([recolorFeedatySvg(svg)], { type: 'image/svg+xml' });
        img.src = URL.createObjectURL(blob);
      })
      .catch(function () {
        img.dataset.bgStarsRecolored = '';
      });
  }

  function recolorAllStars(root) {
    (root || document).querySelectorAll(STAR_SELECTOR).forEach(recolorStarImg);
  }

  function initFeedatyStars(root) {
    root = root || document;
    var reviewsSidebar = root.querySelector
      ? root.querySelector('#bg-psd-reviews')
      : document.getElementById('bg-psd-reviews');
    if (!reviewsSidebar || reviewsSidebar.dataset.bgStarsInit === '1') return;

    reviewsSidebar.dataset.bgStarsInit = '1';
    recolorAllStars(reviewsSidebar);

    new MutationObserver(function () {
      recolorAllStars(reviewsSidebar);
    }).observe(reviewsSidebar, { childList: true, subtree: true });
  }

  function boot() {
    initFeedatyStars(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initFeedatyStars(e.target || document);
  });
})();

/* ============================================================
   bg-multi-content – custom video controls (play / mute)
   ============================================================ */

   (function () {
    var iconPlay =
      '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M8 5v14l11-7z"/></svg>';
    var iconPause =
      '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/></svg>';
    var iconSound =
      '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/></svg>';
    var iconMuted =
      '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/></svg>';
  
    function stopEvt(e) {
      e.preventDefault();
      e.stopPropagation();
    }
  
    function initVideoControls(root) {
      root = root || document;
  
      root.querySelectorAll('.bg-multi-content').forEach(function (section) {
        section.querySelectorAll('video-section').forEach(function (videoSection) {
          var video = videoSection.querySelector('video');
          if (!video || videoSection.dataset.bgControlsInit === '1') return;
  
          videoSection.dataset.bgControlsInit = '1';
  
          // Forza comportamento più stabile su mobile
          video.muted = true;
          video.playsInline = true;
          video.setAttribute('playsinline', '');
  
          // Legge la posizione dei controlli dal data-attribute
          var controlsPosition = videoSection.dataset.controlsPosition || 'right';
  
          // Wrapper pulsanti
          var controls = document.createElement('div');
          controls.className = 'bg-video-controls bg-video-controls--' + controlsPosition;
  
          // Evita che click/tap sul wrapper attivi handler del parent
          controls.addEventListener('pointerdown', stopEvt);
          controls.addEventListener('click', stopEvt);
          controls.addEventListener('touchstart', stopEvt, { passive: false });
  
          // Pulsante Play/Pause
          var playBtn = document.createElement('button');
          playBtn.type = 'button';
          playBtn.className = 'bg-video-btn bg-video-btn--play';
          playBtn.setAttribute('aria-label', 'Play / Pausa');
          playBtn.innerHTML =
            '<span class="bg-video-icon bg-video-icon--play">' + iconPlay + '</span>' +
            '<span class="bg-video-icon bg-video-icon--pause">' + iconPause + '</span>';
  
          // Pulsante Mute/Unmute
          var muteBtn = document.createElement('button');
          muteBtn.type = 'button';
          muteBtn.className = 'bg-video-btn bg-video-btn--mute is-muted';
          muteBtn.setAttribute('aria-label', 'Attiva / Disattiva audio');
          muteBtn.innerHTML =
            '<span class="bg-video-icon bg-video-icon--sound">' + iconSound + '</span>' +
            '<span class="bg-video-icon bg-video-icon--muted">' + iconMuted + '</span>';
  
          controls.appendChild(playBtn);
          controls.appendChild(muteBtn);
          videoSection.appendChild(controls);
  
          function syncUI() {
            playBtn.classList.toggle('is-playing', !video.paused && !video.ended);
            muteBtn.classList.toggle('is-muted', !!video.muted);
            playBtn.setAttribute('aria-pressed', String(!video.paused && !video.ended));
            muteBtn.setAttribute('aria-pressed', String(!video.muted));
          }
  
          // Sync su più eventi (stati browser diversi)
          ['play', 'playing', 'pause', 'ended', 'waiting', 'stalled'].forEach(function (evt) {
            video.addEventListener(evt, syncUI);
          });
          video.addEventListener('volumechange', syncUI);
  
          // Stato iniziale
          syncUI();
  
          var playLock = false;
  
          function safePlay() {
            var p = video.play();
            // Alcuni browser ritornano undefined
            if (p && typeof p.then === 'function') {
              return p.catch(function (err) {
                // Evita blocchi silenziosi / errori non gestiti
                console.warn('Video play() bloccato/interrotto:', err);
              });
            }
            return Promise.resolve();
          }
  
          playBtn.addEventListener('pointerdown', stopEvt);
          playBtn.addEventListener('click', async function (e) {
            stopEvt(e);
            if (playLock) return;
            playLock = true;
  
            try {
              if (video.paused || video.ended) {
                // Se è finito, riparti dall'inizio
                if (video.ended) video.currentTime = 0;
                await safePlay();
              } else {
                video.pause();
              }
            } finally {
              syncUI();
              // piccolo delay anti double-click race
              setTimeout(function () {
                playLock = false;
              }, 120);
            }
          });
  
          muteBtn.addEventListener('pointerdown', stopEvt);
          muteBtn.addEventListener('click', function (e) {
            stopEvt(e);
            video.muted = !video.muted;
            syncUI();
          });
        });
      });
    }
  
    function boot() {
      initVideoControls(document);
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  
    // Shopify Theme Editor / section reload dinamici
    document.addEventListener('shopify:section:load', function (e) {
      initVideoControls(e.target || document);
    });
    document.addEventListener('shopify:section:reorder', function () {
      initVideoControls(document);
    });
  })();

/* ============================================================
   BG Newsletter popup – cookie funzionale (30 gg) + delay

   La modale non si basa più su sessionStorage: alla chiusura,
   per qualsiasi motivo (X, overlay, rifiuto, Escape, invio form),
   viene salvato il cookie funzionale "bg_newsletter_popup" con
   validità 30 giorni. Finché il cookie è presente la modale non
   viene più mostrata.
   ============================================================ */

(function () {
  var COOKIE_NAME = 'bg_newsletter_popup';
  var COOKIE_DAYS = 30;
  var BODY_LOCK_CLASS = 'bg-nlp-body-lock';
  var OPEN_CLASS = 'is-open';

  function getPopup() {
    return document.getElementById('bg-newsletter-popup');
  }

  function hasCookieBlock() {
    try {
      return new RegExp('(?:^|;\\s*)' + COOKIE_NAME + '=').test(document.cookie);
    } catch (e) {
      return false;
    }
  }

  function setNewsletterCookie(status) {
    try {
      var expires = new Date(Date.now() + COOKIE_DAYS * 24 * 60 * 60 * 1000).toUTCString();
      document.cookie =
        COOKIE_NAME + '=' + encodeURIComponent(status || 'dismissed') +
        '; expires=' + expires +
        '; path=/; SameSite=Lax';
    } catch (e) {}
  }

  /* Esposta globalmente per essere richiamata anche dallo script
     inline in snippets/bg-newsletter-popup.liquid dopo l'invio riuscito. */
  window.bgSetNewsletterCookie = setNewsletterCookie;

  function shouldSkip(popup) {
    if (!popup) return true;
    /* Mai in theme editor — solo storefront live */
    if (window.Shopify && Shopify.designMode) return true;
    if (hasCookieBlock()) return true;

    if (popup.dataset.customerSubscribed === 'true') return true;

    if (popup.dataset.pages === 'homepage' && !document.body.classList.contains('index')) {
      return true;
    }

    if (popup.dataset.showMobile !== 'true' && window.innerWidth < 768) {
      popup.classList.add('bg-nlp--hide-mobile');
      return true;
    }

    return false;
  }

  function openPopup(popup) {
    if (!popup || popup.classList.contains(OPEN_CLASS)) return;

    popup.removeAttribute('hidden');
    popup.setAttribute('aria-hidden', 'false');
    popup.classList.add(OPEN_CLASS);
    document.body.classList.add(BODY_LOCK_CLASS);

    var focusTarget = popup.querySelector('.bg-nlp__close') || popup;
    if (focusTarget && focusTarget.focus) focusTarget.focus();
  }

  function closePopup(popup, status) {
    if (!popup) return;

    popup.classList.remove(OPEN_CLASS);
    popup.setAttribute('aria-hidden', 'true');
    popup.setAttribute('hidden', '');
    document.body.classList.remove(BODY_LOCK_CLASS);
    setNewsletterCookie(status || 'dismissed');
  }

  function bindPopup(popup) {
    if (!popup || popup.dataset.bgNlpInit === '1') return;
    popup.dataset.bgNlpInit = '1';

    popup.querySelectorAll('[data-bg-nlp-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        closePopup(popup, 'dismissed');
      });
    });

    var refuseBtn = popup.querySelector('[data-bg-nlp-refuse]');
    if (refuseBtn) {
      refuseBtn.addEventListener('click', function () {
        closePopup(popup, 'dismissed');
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains(OPEN_CLASS)) {
        closePopup(popup, 'dismissed');
      }
    });
  }

  function schedulePopup(popup) {
    if (shouldSkip(popup)) return;

    bindPopup(popup);

    if (popup.querySelector('.bg-nlp__message--success') || popup.querySelector('.bg-nlp__message--error')) {
      openPopup(popup);
      return;
    }

    var delay = parseInt(popup.dataset.delay, 10);
    if (isNaN(delay) || delay < 0) delay = 5;

    setTimeout(function () {
      if (window.Shopify && Shopify.designMode) return;
      if (hasCookieBlock()) return;
      openPopup(popup);
    }, delay * 1000);
  }

  function initNewsletterPopup(root) {
    root = root || document;
    var popup = root.getElementById
      ? root.getElementById('bg-newsletter-popup')
      : getPopup();
    if (!popup) return;
    schedulePopup(popup);
  }

  function boot() {
    initNewsletterPopup(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    initNewsletterPopup(document);
  });
})();


/* ============================================================
   Sidebar SKU — aggiornamento dinamico al cambio variante
   Ascolta il change su input[name="id"] che il tema dispatcha
   in updateVariantInput() ogni volta che la variante cambia.
   ============================================================ */
(function () {
  var skuMap = null;

  function getSkuMap() {
    if (skuMap) return skuMap;
    var el = document.getElementById('bg-psd-variant-skus');
    if (!el) return null;
    try { skuMap = JSON.parse(el.textContent); } catch (e) { skuMap = {}; }
    return skuMap;
  }

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.getAttribute('name') !== 'id') return;
    var skuSpan = document.getElementById('bg-psd-sku');
    if (!skuSpan) return;
    // Se è impostato custom.parent_sku non aggiornare: è sempre fisso
    if (skuSpan.dataset.parentSku) return;
    var map = getSkuMap();
    if (!map) return;
    var sku = map[input.value];
    skuSpan.textContent = 'SKU: ' + (sku || 'N/A');
  });
})();

/* ============================================================
   Grid-mode click da modalità lista → naviga verso griglia
   Intercetta il click in fase di capture prima che GridMode (collection.js)
   lo gestisca con solo swap CSS, che non funziona da list mode.
   ============================================================ */
document.addEventListener('click', function (e) {
  var gridModeEl = e.target.closest('grid-mode[data-grid-mode]');
  if (!gridModeEl) return;
  var container = document.querySelector('.container-products-switch');
  if (!container || !container.classList.contains('list')) return;

  e.stopImmediatePropagation();

  if (typeof eventCollectionShopify === 'undefined') return;
  var queryString = window.location.search;
  queryString = eventCollectionShopify.removeParam('view', queryString);
  var searchParams = queryString.replace('?', '') + '&view=grid';
  var url = eventCollectionShopify.renderUrl(searchParams);
  eventCollectionShopify.renderSectionFilter(url, searchParams);
}, true);

/* ============================================================
   Collection mobile — solo griglia 2/3 colonne
   ============================================================ */
(function () {
  function initMobileCollectionGrid() {
    if (!window.matchMedia('(max-width: 1024px)').matches) return;

    var container = document.querySelector('.container-products-switch.bg-collection-grid');
    if (!container) return;

    if (container.classList.contains('list') && typeof eventCollectionShopify !== 'undefined') {
      var queryString = window.location.search;
      queryString = eventCollectionShopify.removeParam('view', queryString);
      var searchParams = queryString.replace('?', '');
      var url = eventCollectionShopify.renderUrl(searchParams);
      eventCollectionShopify.renderSectionFilter(url, searchParams);
      return;
    }

    var cols = container.dataset.mobileColumns;
    if (!cols) return;

    document.querySelectorAll('.sec__collection-main .show-type-products grid-mode').forEach(function (el) {
      el.classList.remove('active', 'active-mobile');
      if (el.dataset.gridMode === cols) {
        el.classList.add('active');
      }
    });

    container.classList.remove('grid-columns-2', 'grid-columns-3', 'grid-columns-4', 'grid-columns-5');
    container.classList.add('grid-columns-' + cols);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileCollectionGrid);
  } else {
    initMobileCollectionGrid();
  }
})();

/* ============================================================
   Floating buttons — offset in fondo pagina (back-to-top + Sea A11y)
   ============================================================ */

(function () {
  function updateFloatingButtons() {
    var atBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 48;
    var buttons = document.querySelectorAll('back-to-top, #Sea-Accessibility__ButtonWidget');

    buttons.forEach(function (btn) {
      btn.classList.toggle('is-at-bottom', atBottom);
    });
  }

  window.addEventListener('scroll', updateFloatingButtons, { passive: true });
  updateFloatingButtons();
})();

/* ============================================================
   BG Product Gallery — Zoom (lightbox + Drift)
   Markup: sections/main-product.liquid (.bg-product-gallery-wrap[data-bg-zoom])
   Comportamento allineato a zoom-action del tema:
   - open_lightbox → PhotoSwipe (desktop + mobile) + icona hover
   - inner/external → Drift su desktop ≥768, PhotoSwipe su mobile
   - no_zoom → nessuna azione
   ============================================================ */
(function () {
  var DESKTOP_MQ = 768;
  var pswpModulesPromise = null;
  var activeLightbox = null;

  function loadPhotoSwipe(wrap) {
    if (pswpModulesPromise) return pswpModulesPromise;
    var lightboxUrl = wrap.getAttribute('data-pswp-lightbox');
    var moduleUrl = wrap.getAttribute('data-pswp-module');
    if (!lightboxUrl || !moduleUrl) {
      return Promise.reject(new Error('PhotoSwipe assets missing'));
    }
    pswpModulesPromise = Promise.all([
      import(lightboxUrl),
      import(moduleUrl)
    ]).then(function (mods) {
      return {
        PhotoSwipeLightbox: mods[0].default,
        PhotoSwipe: mods[1].default
      };
    });
    return pswpModulesPromise;
  }

  function collectItems(wrap) {
    return Array.prototype.map.call(
      wrap.querySelectorAll('[data-bg-lightbox-src]'),
      function (el) {
        return {
          src: el.getAttribute('data-bg-lightbox-src'),
          width: parseInt(el.getAttribute('data-bg-lightbox-width'), 10) || 1200,
          height: parseInt(el.getAttribute('data-bg-lightbox-height'), 10) || 1200,
          alt: el.getAttribute('data-bg-lightbox-alt') || ''
        };
      }
    );
  }

  function registerUi(lightbox) {
    lightbox.on('uiRegister', function () {
      var pswp = lightbox.pswp;
      if (!pswp || !pswp.ui) return;

      pswp.ui.registerElement({
        name: 'bls--close',
        isButton: true,
        tagName: 'button',
        html: '<svg width="13" height="13" viewBox="0 0 13 13" fill="none" class="transition"><use href="#icon-close"></use></svg>',
        onClick: function () {
          pswp.close();
        }
      });

      pswp.ui.registerElement({
        name: 'bottomBar',
        className: 'pswp__bottom-bar',
        appendTo: 'wrapper',
        onInit: function (el, pswpInstance) {
          var next = document.createElement('button');
          next.setAttribute('type', 'button');
          next.className = 'pswp__button pswp__button-next';
          next.innerHTML = '<svg width="6" height="11" fill="none"><use href="#icon-next"></use></svg>';
          next.onclick = function () {
            pswpInstance.next();
          };
          el.appendChild(next);

          var counter = document.createElement('span');
          counter.className = 'pswp__counter';
          pswpInstance.on('change', function () {
            counter.innerText =
              pswpInstance.currIndex +
              1 +
              pswpInstance.options.indexIndicatorSep +
              pswpInstance.getNumItems();
          });
          el.appendChild(counter);

          var prev = document.createElement('button');
          prev.setAttribute('type', 'button');
          prev.className = 'pswp__button pswp__button-prev';
          prev.innerHTML = '<svg width="6" height="11" fill="none"><use href="#icon-back"></use></svg>';
          prev.onclick = function () {
            pswpInstance.prev();
          };
          el.appendChild(prev);
        }
      });
    });
  }

  function openLightbox(wrap, index) {
    var items = collectItems(wrap);
    if (!items.length) return;

    loadPhotoSwipe(wrap)
      .then(function (mods) {
        if (activeLightbox) {
          try {
            activeLightbox.destroy();
          } catch (e) {}
          activeLightbox = null;
        }

        var lightbox = new mods.PhotoSwipeLightbox({
          dataSource: items,
          pswpModule: mods.PhotoSwipe,
          counter: false,
          zoom: false,
          preloader: false,
          arrowPrev: false,
          arrowNext: false,
          close: false,
          loop: false,
          bgOpacity: 1
        });

        registerUi(lightbox);
        lightbox.init();
        lightbox.loadAndOpen(Math.max(0, Math.min(index, items.length - 1)));
        activeLightbox = lightbox;

        lightbox.on('destroy', function () {
          if (activeLightbox === lightbox) activeLightbox = null;
        });
      })
      .catch(function (err) {
        console.warn('[bg-product-zoom]', err);
      });
  }

  function destroyDrift(wrap) {
    var instances = wrap._bgDriftInstances;
    if (!instances || !instances.length) return;
    instances.forEach(function (drift) {
      try {
        if (drift && typeof drift.destroy === 'function') drift.destroy();
      } catch (e) {}
    });
    wrap._bgDriftInstances = [];
  }

  function initDrift(wrap) {
    if (typeof window.Drift === 'undefined') return;
    if (wrap._bgDriftInstances && wrap._bgDriftInstances.length) return;

    var zoomOption = wrap.getAttribute('data-bg-zoom-option') || 'inner-1';
    var sectionRoot = wrap.closest('.sec__featured-product');
    var externalPane = sectionRoot
      ? sectionRoot.querySelector('.zoom-external-area')
      : null;
    var triggers = wrap.querySelectorAll('.drift-trigger');
    var instances = [];

    triggers.forEach(function (trigger) {
      var inlineContainer = trigger.closest('[data-pane-container]');
      if (!inlineContainer) inlineContainer = trigger.parentElement;
      var opts;

      if (zoomOption === 'inner-2') {
        opts = {
          sourceAttribute: 'data-zoom',
          inlinePane: true,
          zoomFactor: 3,
          containInline: true,
          paneContainer: inlineContainer,
          hoverBoundingBox: false,
          onShow: function () {
            inlineContainer.classList.add('relative');
          },
          onHide: function () {
            inlineContainer.classList.remove('relative');
          }
        };
      } else {
        opts = {
          sourceAttribute: 'data-zoom',
          /* come tema: stringa truthy → su external diventa pane esterno via NaN check */
          inlinePane: zoomOption === 'external' ? false : 375,
          zoomFactor: 5,
          containInline: zoomOption !== 'external',
          paneContainer:
            zoomOption === 'external' && externalPane
              ? externalPane
              : inlineContainer,
          hoverBoundingBox: zoomOption === 'external',
          onShow: function () {
            inlineContainer.classList.add('relative');
          },
          onHide: function () {
            inlineContainer.classList.remove('relative');
          }
        };
      }

      try {
        instances.push(new window.Drift(trigger, opts));
      } catch (err) {
        console.warn('[bg-product-zoom] Drift init failed', err);
      }
    });

    wrap._bgDriftInstances = instances;
  }

  function isDesktop() {
    return window.innerWidth >= DESKTOP_MQ;
  }

  function applyZoomMode(wrap) {
    var type = wrap.getAttribute('data-bg-zoom') || 'no_zoom';
    if (type === 'no_zoom') {
      destroyDrift(wrap);
      return;
    }

    if (type === 'open_lightbox') {
      destroyDrift(wrap);
      return;
    }

    /* inner / external */
    if (isDesktop()) {
      initDrift(wrap);
    } else {
      destroyDrift(wrap);
    }
  }

  function shouldOpenLightbox(wrap) {
    var type = wrap.getAttribute('data-bg-zoom') || 'no_zoom';
    if (type === 'no_zoom') return false;
    if (type === 'open_lightbox') return true;
    /* Drift modes: lightbox solo su mobile */
    return !isDesktop();
  }

  function bindGallery(wrap) {
    if (!wrap || wrap.dataset.bgZoomInit === '1') return;
    wrap.dataset.bgZoomInit = '1';

    wrap.addEventListener('click', function (e) {
      var trigger = e.target.closest('.bg-product-lightbox-trigger');
      if (!trigger || !wrap.contains(trigger)) return;

      if (!shouldOpenLightbox(wrap)) {
        /* Desktop Drift: blocca navigazione link se presente, niente lightbox */
        if (trigger.tagName === 'A') e.preventDefault();
        return;
      }

      e.preventDefault();
      e.stopPropagation();

      var triggers = wrap.querySelectorAll('.bg-product-lightbox-trigger');
      var index = Array.prototype.indexOf.call(triggers, trigger);
      if (index < 0) index = 0;
      openLightbox(wrap, index);
    });

    applyZoomMode(wrap);

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        applyZoomMode(wrap);
      }, 150);
    });
  }

  function initBgProductZoom(root) {
    root = root || document;
    root.querySelectorAll('.bg-product-gallery-wrap[data-bg-zoom]').forEach(bindGallery);
  }

  function boot() {
    initBgProductZoom(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('load', function () {
    document.querySelectorAll('.bg-product-gallery-wrap[data-bg-zoom]').forEach(applyZoomMode);
  });

  document.addEventListener('shopify:section:load', function () {
    initBgProductZoom(document);
  });
})();

